import http from '@/utils/http';

// 学生总人数
export const getStudentTotal = (params) => {
    return http({
        url: '/api/visualcss/v2/index/student/all',
        method: 'get',
        params
    })
}
//  今年学生人数
export const getStudentYear = (params) => {
    return http({
        url: '/api/visualcss/v2/index/student/year',
        params
    })
}
//  教师人数
export const getTeacherTotal = (params) => {
    return http({
        url: '/api/visualcss/v2/index/teacher/all',
        params
    })
}
//  各学段学生人数（柱状图 按学段分类）
export const getStudentNumBySection = (params) => {
    return http({
        url: '/api/visualcss/v2/index/student/section',
        params
    })
}
//  学生障碍类型占比（环形图）
export const getStudentDisability = (params) => {
    return http({
        url: '/api/visualcss/v2/index/studentDisability/all',
        params
    })
}
//  学生障碍类型占比分学段（柱状图）
export const getStudentDisability2 = (params) => {
    return http({
        url: '/api/visualcss/v2/index/studentDisability',
        params
    })
}




